<!-- 商品SPU-商品SKU -->
<template>
  <div class="ADD_SKU">
    <OmsButton :btn-config="btnConfig" />
    <OrderItem ref="OrderItem" :component-data="tabConfig" @reset-table="resetTable" />
    <Modal
      v-model="isModal"
      :title="t('警告')"
      titleAlign="left"
      mask
      closable
      footer-hide
      width="400"
    >
      <div class="tip">{{ t('当前商品，没有维护相关SKU信息，请选择保存逻辑') }}</div>
      <OmsButton :btn-config="btnConfig2" class="modal-footer" />
    </Modal>
  </div>
</template>
<script>
import OrderItem from 'allpages/orderCenter/orderManageDetail/details/orderItem.vue';
import { mapMutations } from 'vuex';
export default {
  components: {
    OrderItem
  },
  data() {
    return {
      isModal: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'left',
        buttons: [
          {
            text: t('新增'),
            btnclick: () => {
              let row = {}
              let keys = this.$refs.OrderItem.tableConfig.columns.map(i => i.key)
              keys.forEach(key => row[key] = '')
              this.$refs.OrderItem.tableConfig.data.push(row)
            },
          },
        ]
      },
      btnConfig2: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right',
        buttons: [
          {
            text: t('保存，且生成一笔同编码的SKU'),
            type: 'primary',
            btnclick: () => {
              this.save('Y')
            },
          },
          {
            text: t('仅保存商品SPU'),
            type: 'primary',
            btnclick: () => {
              this.save('N')
            },
          },
        ]
      },
      tabConfig: {
        objid: -1,
        isNew: true,
        tablename: 'PS_C_RPO_ITEM',
        ref: {
          table: 'PS_C_PRO_ITEM',
          refcolid: 1700860341,
          searchdata: {
            column_include_uicontroller: true,
            range: 10,
            startindex: 0
          },
        },
        tableConfig: {
          pageShow: false,
          width: '0'
        }
      },
    }
  },
  activated() {
    this.pageStyle();
  },
  mounted() {
    window.addEventListener('resize', this.pageStyle, false);
    // 先清理页面
    setTimeout(() => {
      this.pageStyle()
      document.querySelector('.NaVertical .NaVertical-icons .iconfont').addEventListener('click', this.pageStyle, false);
    }, 900);
    setTimeout(() => {
      // 商品SPU保存按钮
      if (this.$route.params.itemId == 'New') {
        document.querySelector('#actionMODIFY').style.display = 'none';
      } else {
        document.querySelector('.PS_C_PRO_SAVE').style.display = 'none';
      }
      document.querySelector('.PS_C_PRO_SAVE').addEventListener('click', () => {
        const category = document.querySelector('.CATEGORY_NAME') // 商品类目
        if (category) {
          const vm = category.__vue__
          vm && !vm.isDisabled && vm.init()
        }
        const singleObjectButton = $('#PS_C_PRO .singleObjectButton')[0].__vue__
        if (singleObjectButton.verifyRequiredmainInformation()) {
          const data = this.$refs.OrderItem.tableConfig && this.$refs.OrderItem.tableConfig.data
          const hasRowNoEmpty = data && data.length > 0 && data.some(i => this.rowString(i) != '')
          if (hasRowNoEmpty) {
            this.save('N')
          } else {
            this.isModal = true
          }
        }
      }, false)
    }, 300)
  },
  methods: {
    ...mapMutations('omsStore', ['setAddSKU']),
    save(val) {
      const arg = { data: this.$refs.OrderItem.tableConfig.data.filter(i => this.rowString(i) != '') }
      this.setAddSKU(arg)
      val && (arg.IS_ONE_STYLE_ONE_CODE = val)
      document.querySelector('#actionMODIFY').click()
      this.isModal = false
    },
    pageStyle() {
      $('.ADD_SKU').parent().parent().find('.itemLabel').remove();
      $(`.ark-collapse[data-name="${this.$parent.$parent.$parent.$parent.name}"] .content.R3masterForm`).attr('style', '');
      setTimeout(() => {
        const tableWidth = window.innerWidth - $('.NavigatorVertical')[0].offsetWidth - 95
        $('.ADD_SKU .jordan-table.ark-table-wrapper')[0].style.width = `${tableWidth}px`
      }, 0)
    },
    resetTable() {
      const isExistDel = this.$refs.OrderItem.tableConfig.columns.some(i => i.key == 'IS_DELETE')
      !isExistDel && this.$refs.OrderItem.tableConfig.columns.push({
        key: 'IS_DELETE',
        title: t('操作'),
        width: '95',
        render: (h, params) => {
          return h('a',
            {
              on: {
                click: () => {
                  this.$refs.OrderItem.tableConfig.data.splice(params.index, 1)
                }
              }
            },
            t('删除')
          )
        }
      })
      this.$refs.OrderItem.tableConfig.columns.forEach(element => {
        if (element.key == 'IS_DELETE') return
        const col1 = ['PS_C_PRO_ID', 'ECODE', 'GBCODE']
        element.width = col1.includes(element.key) ? '200' : '120'
        element.render = (h, params) => {
          return h('Input', {
            props: {
              value: params.row[element.key],
              regx: col1.includes(element.key) ? '' : /^\d*\.{0,1}\d{0,4}$/
            },
            on: {
              'on-change': (e) => {
                params.row[element.key] = e.target.value;
                this.$refs.OrderItem.tableConfig.data[`${params.index}`] = params.row
              },
            }
          })
        }
      })
    },
    rowString(row) {
      let newRow = _.cloneDeep(row)
      delete newRow._index
      delete newRow._rowKey
      return Object.values(newRow).join('')
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageStyle, false);
  }
}
</script>
<style lang="less" scoped>
.tip {
  height: 50px;
}
</style>